import externalApi from "../api/external";
import {getPublicCredentials} from "./environment";

const getLogoDevCreds = () => getPublicCredentials().logodev_pubkey;

const sanitiseUrl = (urlLike: string | URL) => {
  if (typeof urlLike !== "string") return urlLike;
  if (URL.canParse(urlLike)) return new URL(urlLike);
  if (URL.canParse(`https://${urlLike}`)) return new URL(`https://${urlLike}`);
  return undefined;
};

/**
 * @deprecated
 */
export const getLogoSrc = (domain?: string) => {
  // Strip protocol (anything before ://) if present
  const cleanDomain = domain?.replace(/^.*:\/\//, "");

  return cleanDomain !== undefined && getLogoDevCreds() !== undefined
    ? `https://img.logo.dev/${cleanDomain}?token=${getLogoDevCreds()}`
    : // Don't load logos when we don't have a key set.
      "";
};

export const getLogoSrcSrcset = (urlLike?: string | URL) => {
  const cred = getLogoDevCreds();
  if (!cred || !urlLike) return {source: {srcSet: "", type: ""}, src: ""};

  const key = sanitiseUrl(urlLike)?.hostname ?? "";

  const src = `https://img.logo.dev/${key}?token=${cred}&fallback=404`;

  const source = {
    type: "image/webp",
    srcSet: [
      externalApi.mediaAssets.getCompanyLogo(key),
      `${externalApi.mediaAssets.getCompanyLogo(key, true)} 2x`,
    ].join(", "),
  };

  return {source, src};
};
